import React from "react";
import SRList from "../../component/List";

export default function ListAllSchool3(props) {
  const { moreSearch } = props;

  const title = "Báo cáo kiểm tra bài tập toàn trường";
  const columns = [
    { name: "id", label: "ID", options: { filter: true, sort: false } },
    { name: "title", label: "Lớp", options: { filter: true, sort: false } },
    { name: "total_1", label: "Số lượt kiểm tra", options: {  filter: true, sort: true,
      customBodyRender: (value, tableMeta) => {
        const total = tableMeta.rowData[3]+tableMeta.rowData[4]+tableMeta.rowData[5];
        return total
      } } },
    {
      name: "total_1",
      label: "Hoàn thành",
      options: { filter: true, sort: true },
    },
    {
      name: "total_2",
      label: "Chưa hoàn thành",
      options: { filter: true, sort: true },
    },
    {
      name: "total_3",
      label: "Không làm",
      options: { filter: false, sort: true },
    },
  ];

  return (
    <>
      <SRList
        name="report_attends_class"
        moresearch={moreSearch}
        params={
          moreSearch
            ? "begin=" +
              moreSearch.begin +
              "&end=" +
              moreSearch.end +
              "&type=" +
              moreSearch.type
            : ""
        }
        title={title}
        defaultLimit={200}
        serverSide={false}
        columns={columns}
        noAction={true}
      ></SRList>
    </>
  );
}
